// extracted by mini-css-extract-plugin
export default {"primaryStyledButton":"StyledButton_primaryStyledButton__BASo3","secondaryStyledButton":"StyledButton_secondaryStyledButton__oxJng"};